import type { AxiosInstance } from 'axios';
import type {
  Plot,
  PlotListQueryParams,
  PlotListResponse,
  PlotCreateRequest,
  PlotUpdateRequest,
  EntityId,
} from '@/types';

export const getPlots = async (
  api: AxiosInstance,
  type: string,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PlotListResponse> => {
  const resp = await api.get<PlotListResponse>('/plot', {
    params: { type, limit, start_key, name } as PlotListQueryParams,
  });
  return resp.data;
};

export const getPlot = async (
  api: AxiosInstance,
  plot_id: EntityId,
): Promise<Plot> => {
  const resp = await api.get<Plot>(`/plot/${plot_id}`);
  return resp.data;
};

export const createPlot = async (
  api: AxiosInstance,
  values: PlotCreateRequest,
): Promise<Plot> => {
  const resp = await api.post<Plot>(`/plot/`, values);
  return resp.data;
};

export const updatePlot = async (
  api: AxiosInstance,
  plot_id: EntityId,
  values: PlotUpdateRequest,
): Promise<Plot> => {
  const resp = await api.put<Plot>(`/plot/${plot_id}`, values);
  return resp.data;
};

export const deletePlot = async (
  api: AxiosInstance,
  plot_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/plot/${plot_id}`);
  return resp.data;
};

export const runPlot = async (
  api: AxiosInstance,
  plot_id: EntityId,
): Promise<unknown> => {
  const resp = await api.post(`/plot/${plot_id}/run`);
  return resp.data;
};

export const finalizePlot = async (
  api: AxiosInstance,
  plot_id: EntityId,
): Promise<unknown> => {
  const resp = await api.post(`/plot/${plot_id}/finalize`);
  return resp.data;
};

